import { LightFilter, ProFormSwitch, useBreakpoint } from '@ant-design/pro-components';

import { useIntl, useModel } from '@umijs/max';

import { useSettings } from '@/services/hooks';

interface FormValues {
  complaint: boolean;
}

const ThresholdSwitch = () => {
  const intl = useIntl();
  const screens = useBreakpoint();

  const { setSelectedThreshold } = useModel('selectedThreshold');

  const { data } = useSettings();

  const handleThresholdChange = ({ complaint }: FormValues) => {
    if (complaint) {
      setSelectedThreshold('complaint');
      return;
    }

    setSelectedThreshold('production');
  };

  return data?.complaintThresholdEnabled && (
    <LightFilter<FormValues>
      autoFocusFirstInput={false}
      className="threshold-switch"
      onFinish={handleThresholdChange}
    >
      <ProFormSwitch
        label={screens !== 'xs' && screens !== 'sm' && intl.formatMessage({ id: 'threshold.complaint' })}
        name="complaint"
      />
    </LightFilter>
  );
};

export default ThresholdSwitch;
